module.exports = __webpack_public_path__ + "src/assets/img/footerLogin.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footerLogin.svg
// module id = h9qI
// module chunks = 80